import { noop } from 'lodash'

type Warning = (warn: any, component: string, message?: any) => void

let warning: Warning = noop

//@ts-ignore
if (process.env.NODE_ENV !== 'production') {
  warning = (warn: boolean, component: string, message: string) => {
    if (warn && console !== undefined) {
      console.error(`Warning: [${component}] ${message}`)
    }
  }
}

export { warning }
